// extracted by mini-css-extract-plugin
module.exports = {"question":"dialog__question___3s5E3","buttons":"dialog__buttons___3L6-6","left-buttons":"dialog__left-buttons___10u6W","right-buttons":"dialog__right-buttons___YgFkI"};